import axios from 'axios';

const Axios = axios.create({
    baseURL: process.env.REACT_APP_PUBLIC_BACKEND_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

let isRefreshing = false;
let subscribers = [];

// Notify all queued requests with the new token
function onTokenRefreshed(token) {
    subscribers.forEach((callback) => callback(token));
    subscribers = [];
}

// Add a request to the queue
function addSubscriber(callback) {
    subscribers.push(callback);
}

// Request Interceptor 
Axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor - handle 401 and refresh
Axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (
            originalRequest.url.includes('/auth/login') ||
            originalRequest.url.includes('/auth/token/refresh')
        ) {
            return Promise.reject(error);
        }

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            if (isRefreshing) {
                // Already refreshing - queue the request
                return new Promise((resolve) => {
                    addSubscriber((token) => {
                        originalRequest.headers.Authorization = `Bearer ${token}`;
                        resolve(Axios(originalRequest));
                    });
                });
            }

            // Start refreshing
            isRefreshing = true;
            try {
                const refreshToken = localStorage.getItem('refreshToken');
                const res = await axios.post(
                    `${process.env.REACT_APP_PUBLIC_BACKEND_URL}auth/token/refresh`,
                    { refreshToken }
                );

                const { token, refreshToken: newRefreshToken } = res.data.data;

                // Save new tokens
                localStorage.setItem('authToken', token);
                localStorage.setItem('refreshToken', newRefreshToken);

                // Retry all queued requests
                onTokenRefreshed(token);

                // Retry the original request with new token
                originalRequest.headers.Authorization = `Bearer ${token}`;
                return Axios(originalRequest);
            } catch (refreshError) {
                // Refresh failed - logout user
                localStorage.removeItem('authToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('accountId');
                localStorage.removeItem('user');
                window.location.href = '/';
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

export default Axios;
